import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { SwTrack } from "app/services/SwTrack";

import { takeActivationPageViewContext } from "./activationPageViewContext";

export const trackActivationHomePageView = ({
    toParams,
    toState,
}: {
    toParams: Record<string, string>;
    toState: IRouterState;
}): void => {
    const activationId = toParams?.key;
    const context = activationId ? takeActivationPageViewContext(activationId) : undefined;

    SwTrack.trackPageView(toState, {
        ...toParams,
        ...(context ? { isAssetOwner: context.isAssetOwner } : {}),
    });
};
